// src/lib/typeMatchers/index.ts
var isMap = (input) => input instanceof Map || input && input.toString() === "[object Map]";
var isSet = (input) => input instanceof Set || input && input.toString() === "[object Set]";
var isDate = (input) => input instanceof Date || input && typeof input.toDateString === "function";

// src/lib/assignable/index.ts
var OBJECT_TYPES = ["object", "function"];
var assignable = (target) => OBJECT_TYPES.includes(typeof target) && target !== null && !isDate(target);

// src/lib/assignArray/index.ts
function assignArray(target, source) {
  if (isSet(source)) {
    source = Array.from(source);
  }
  Array.isArray(source) && source.forEach(
    (item, index) => assignable(target[index]) && assignable(item) ? assign(target[index], item) : target[index] = item === void 0 ? target[index] : item
  );
}

// src/lib/assignSet/index.ts
function assignSet(target, source) {
  if (isSet(source) || Array.isArray(source)) {
    const array = Array.from(target);
    assignArray(array, Array.from(source));
    target.clear();
    array.forEach((item) => target.add(item));
  }
}

// src/lib/assignMap/index.ts
var assignMap = (target, source) => source.forEach((key, value) => target.set(value, key));

// src/lib/clone/index.ts
function clone(instance) {
  if (Array.isArray(instance)) {
    return Array.from(instance);
  } else if (isSet(instance)) {
    return new Set(instance);
  } else if (isMap(instance)) {
    return new Map(instance);
  }
  return Object.assign({}, instance);
}

// src/lib/assignKey/index.ts
var secureKeys = [
  "__proto__",
  "constructor",
  "prototype"
];
function assignKey(target, source, key) {
  if (secureKeys.includes(key)) {
    return;
  }
  target[key] = !(key in target) || !assignable(source[key]) ? source[key] : assign(clone(target[key]), source[key]);
}

// src/lib/assignKeys/index.ts
var assignKeys = (target, source) => Object.keys(source).forEach((key) => assignKey(target, source, key));

// src/lib/assignSymbols/index.ts
var assignSymbols = (target, source) => Object.getOwnPropertySymbols(source).forEach(
  (symbol) => assignKey(target, source, symbol)
);

// src/lib/assign/index.ts
function assign(target, source) {
  if (Array.isArray(target)) {
    assignArray(target, source);
    return target;
  }
  if (isSet(target)) {
    assignSet(target, source);
    return target;
  }
  if (isMap(target) && isMap(source)) {
    assignMap(target, source);
    return target;
  }
  target = Object(target);
  source = Object(source);
  assignKeys(target, source);
  assignSymbols(target, source);
  return target;
}

// src/index.ts
function assign2(target, ...others) {
  assignable(target) && others.forEach((other) => assign(target, other));
  return target;
}
export {
  assign2 as assign
};
//# sourceMappingURL=index.mjs.map